/**
 * Theme Token System
 * Sun Hive Microschool - Brand Colors
 * * Palette: "Natural Paper"
 * Primary: Hunter Green #3C563B
 * Secondary: Goldenrod #FFE68C
 * Backgrounds: Canvas (Off-White) & Surface (Warm Beige)
 * Text: Ink (Deep Forest Black) - No pure black or white.
 */

export const colors = {
  // Brand colors
  brand: {
    green: "#3C563B",
    greenLight: "#4A6B49",
    greenDark: "#2E432D",
    gold: "#FFE68C",
    goldLight: "#FFF0B3",
    goldMuted: "rgba(255, 230, 140, 0.25)",
  },

  // Background colors - The "No White" Rule
  background: {
    default: "#f7f4eeff",           // Canvas: Main page background (Alabaster)
    section: "#F2F0E9",           // Use Surface for section breaks (Gold is too heavy for full sections)
    paper: "#fdf5daff",             // Surface: Cards/Sections (Warm Grey/Beige)
    hover: "#EBE8DE",             // Slightly darker beige for interaction
    overlay: "rgba(250, 249, 246, 0.95)", // Matches Canvas opacity
    buttonOverlay: "rgba(60, 86, 59, 0.08)",
    transparent: "transparent",
    listItem: "rgba(60, 86, 59, 0.04)",   // Very subtle green tint
    accent: "#FFE68C",            // BRAND GOLD: Use for stickers, highlights, or secondary buttons
  },

  // Text colors - The "No Black" Rule
  text: {
    primary: "#1C241D",           // Ink: Deep Forest Black
    secondary: "#3D4A3E",         // Muted Ink: Darkened for contrast (was #4A564B)
    muted: "#5A665B",             // Softer grey-green: Darkened for contrast (was #788279)
    disabled: "rgba(28, 36, 29, 0.4)",
    subtle: "rgba(28, 36, 29, 0.65)", // Slightly darker for contrast
    inverse: "#FAF9F6",           // For text on Green buttons (matches Canvas)
    link: "#3C563B",              // Links are Green
  },

  // Border colors
  border: {
    default: "#DEDBD2",           // Stone: Subtle lines between sections
    light: "rgba(60, 86, 59, 0.1)",
    focus: "#3C563B",             // Focus rings use Primary Green
    subtle: "rgba(60, 86, 59, 0.08)",
    gold: "rgba(255, 230, 140, 0.5)", // For highlighting specific inputs
  },

  // Accent colors
  accent: {
    primary: "#3C563B",
    primaryLight: "#4A6B49",
    secondary: "#FFE68C",
    error: "#C62828",
    success: "#2E7D32",
    grey: "#757575",
  },
};

// Convenience exports for common patterns
export const { background, text, border, accent, brand } = colors;

export default colors;